import de from './locales/de.json';
import en from './locales/en.json';
import esAr from './locales/es-ar.json';
import es from './locales/es.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import hu from './locales/hu.json';
import it from './locales/it.json';
import lb from './locales/lb.json';
import lt from './locales/lt.json';
import nl from './locales/nl.json';
import ro from './locales/ro.json';
import sv from './locales/sv.json';

export default {
  'es-ar': esAr,
  de,
  en,
  es,
  fi,
  fr,
  hu,
  it,
  lb,
  lt,
  nl,
  ro,
  sv,
};
